// Belege des Verkaufs per E-Mail (docs/anmeldung/SPEZIFIKATION.md §5.2, §8.2): Angebot, Auftragsbestätigung,
// Lieferschein – der Beleg steht im Mailtext, ohne Anhang. Empfänger ohne Angabe: Ansprechpartner des Kunden mit
// E-Mail, sonst die E-Mail des Kunden. Aufträge aus der Bestell-App bestätigt die App selbst – dort gibt es keine
// Auftragsbestätigung per E-Mail aus Merxo (keine doppelte Bestätigung).
//
// Zu jeder Sendeaktion eine lesende Vorschau mit derselben Eingabe (…Preview) für den Senden-Dialog.
import { defineContract } from '@shared/contract'
import { zDocumentMailInput, zMailPreviewResult, zMailQueuedResult } from '@shared/mailSend'

export const SALES_SEND_PERMISSION = 'sales.document.send'

const LLM_COMMON =
  'Nur festgeschriebene Belege. Ohne `to` an den Ansprechpartner des Kunden bzw. seine hinterlegte E-Mail. ' +
  'Persönliche Nachricht höchstens 1000 Zeichen. Versand nach dem Rückgängig-Fenster.'

export const quoteSend = defineContract({
  name: 'sales.quote.send',
  title: 'Angebot per E-Mail senden',
  description: 'Sendet ein abgegebenes Angebot per E-Mail an den Kunden – das Angebot steht im Mailtext.',
  llm: { description: `Sendet EIN abgegebenes Angebot per E-Mail an den Kunden. ${LLM_COMMON}`, keywords: ['Angebot schicken', 'Angebot per E-Mail', 'Angebot mailen'] },
  input: zDocumentMailInput,
  output: zMailQueuedResult,
  permission: SALES_SEND_PERMISSION,
  risk: 'write',
  scope: 'record',
  effects: { external: true, reversible: true },
})

export const quoteSendPreview = defineContract({
  name: 'sales.quote.sendPreview',
  title: 'Angebot per E-Mail – Vorschau',
  description: 'Zeigt, wie die E-Mail mit dem Angebot aussieht: Empfänger-Vorschlag, Betreff und Inhalt.',
  llm: { description: 'Zeigt die E-Mail zu einem Angebot, bevor sie versendet wird. Verändert nichts. Versenden: sales.quote.send.', keywords: [] },
  input: zDocumentMailInput,
  output: zMailPreviewResult,
  permission: SALES_SEND_PERMISSION,
  risk: 'read',
  scope: 'record',
})

export const orderSendConfirmation = defineContract({
  name: 'sales.order.sendConfirmation',
  title: 'Auftragsbestätigung per E-Mail senden',
  description: 'Sendet die Bestätigung eines bestätigten Auftrags per E-Mail an den Kunden – nicht für Aufträge aus der Bestell-App.',
  llm: {
    description: `Sendet die Auftragsbestätigung EINES bestätigten Auftrags per E-Mail an den Kunden. Nicht für Aufträge aus der Bestell-App (die App bestätigt selbst). ${LLM_COMMON}`,
    keywords: ['Auftragsbestätigung schicken', 'Auftrag bestätigen per E-Mail', 'AB mailen'],
  },
  input: zDocumentMailInput,
  output: zMailQueuedResult,
  permission: SALES_SEND_PERMISSION,
  risk: 'write',
  scope: 'record',
  effects: { external: true, reversible: true },
})

export const orderSendPreview = defineContract({
  name: 'sales.order.sendPreview',
  title: 'Auftragsbestätigung per E-Mail – Vorschau',
  description: 'Zeigt, wie die E-Mail mit der Auftragsbestätigung aussieht: Empfänger-Vorschlag, Betreff und Inhalt.',
  llm: { description: 'Zeigt die E-Mail zu einer Auftragsbestätigung, bevor sie versendet wird. Verändert nichts. Versenden: sales.order.sendConfirmation.', keywords: [] },
  input: zDocumentMailInput,
  output: zMailPreviewResult,
  permission: SALES_SEND_PERMISSION,
  risk: 'read',
  scope: 'record',
})

export const deliverySend = defineContract({
  name: 'sales.delivery.send',
  title: 'Lieferschein per E-Mail senden',
  description: 'Sendet einen gebuchten Lieferschein per E-Mail an den Kunden – der Lieferschein steht im Mailtext.',
  llm: { description: `Sendet EINEN gebuchten Lieferschein per E-Mail an den Kunden. ${LLM_COMMON}`, keywords: ['Lieferschein schicken', 'Lieferschein per E-Mail', 'Lieferschein mailen'] },
  input: zDocumentMailInput,
  output: zMailQueuedResult,
  permission: SALES_SEND_PERMISSION,
  risk: 'write',
  scope: 'record',
  effects: { external: true, reversible: true },
})

export const deliverySendPreview = defineContract({
  name: 'sales.delivery.sendPreview',
  title: 'Lieferschein per E-Mail – Vorschau',
  description: 'Zeigt, wie die E-Mail mit dem Lieferschein aussieht: Empfänger-Vorschlag, Betreff und Inhalt.',
  llm: { description: 'Zeigt die E-Mail zu einem Lieferschein, bevor sie versendet wird. Verändert nichts. Versenden: sales.delivery.send.', keywords: [] },
  input: zDocumentMailInput,
  output: zMailPreviewResult,
  permission: SALES_SEND_PERMISSION,
  risk: 'read',
  scope: 'record',
})
